export const authenticate = (
	name: string,
	role: string,
	email: string,
	company: string,
	token?: string,
	refreshToken?: string
): void => {
	localStorage.setItem('user_name', name);

	localStorage.setItem('user_role', role);

	localStorage.setItem('user_email', email);

	localStorage.setItem('user_company', company);

	if (token && !sessionStorage.admin_token) {
		localStorage.setItem('user_token', token);
	}

	if (refreshToken) {
		localStorage.setItem('user_refresh_token', refreshToken);
	}
};

export const logOut = (): void => {
	localStorage.removeItem('user_token');

	localStorage.removeItem('user_refresh_token');

	localStorage.removeItem('user_name');

	localStorage.removeItem('user_role');

	localStorage.removeItem('user_email');

	localStorage.removeItem('user_company');
};

export const getUserRefreshToken = (): string =>
	localStorage.user_refresh_token;
export const getUserToken = (): string => localStorage.user_token;
export const setUserToken = (token: string): void =>
	localStorage.setItem('user_token', token);

export const getAdminToken = (): string => sessionStorage.admin_token;

export const getUserName = (): string => localStorage.user_name;
export const setUserName = (name: string): void =>
	localStorage.setItem('user_name', name);

export const getUserRole = (): string => localStorage.user_role;
export const setUserRole = (role: string): void =>
	localStorage.setItem('user_role', role);

export const getUserEmail = (): string => localStorage.user_email;
export const setUserEmail = (email: string): void =>
	localStorage.setItem('user_email', email);

export const getUserCompany = (): string => localStorage.user_company;
export const setUserCompany = (company: string): void =>
	localStorage.setItem('user_company', company);

export const clear = (): void => localStorage.clear();
